import React, { useState, useContext }  from 'react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../stores/root_store';

import { Identity, IdentityProps } from '../stores/identity_store';

export type IdentityContextType = {
    //    loadingIdentities: boolean
    identities: Identity[]
    fetchIdentity: (myIdentity: string, identityKey: string) => (void)
    getIdentity: (identityKey: string) => Identity | null,
    fetchAllIdentities: (identityKey: string) => Promise<void>,
    sudoSetVerified: (identityKey: string, verified: boolean) => Promise<Identity>,
    sudoSetDedicated: (identityKey: string, dedicated: boolean) => Promise<Identity>,
    supportFetchIdentityForUser: (userKey: string) => Promise<Identity>,
    sudoSetOnCallSupport: (shfit: string, identityKey: string) => Promise<Identity>,
    supportGetUserUuid: (identityKey: string) => Promise<string | null>,
    managerCreateIdentity: (
        workKey: string,
        user_uuid: string,
        name: string
    ) => Promise<IdentityProps | null>,

    fetchListByTeam: (identity: string, team: string) => Promise<IdentityProps[]>,
    fetchListByDedicated: (identity: string) => Promise<IdentityProps[]>,

}


const IdentityContext = React.createContext<IdentityContextType>({
    //    loadingIdentities: true,
    identities: [] as Identity[],
    fetchIdentity: () => { throw new Error("not implemented") },
    fetchAllIdentities: () => { throw new Error("not implemented") },
    getIdentity: () => { throw new Error("not implemented") },
    sudoSetVerified: () => { throw new Error("not implemented") },
    sudoSetDedicated: () => { throw new Error("not implemented") },
    sudoSetOnCallSupport: () => { throw new Error("not implemented") },
    supportFetchIdentityForUser: () => { throw new Error("not implemented") },
    supportGetUserUuid: () => { throw new Error("not implemented") },
    managerCreateIdentity: () => { throw new Error("not implemented") },
    fetchListByTeam: () => { throw new Error("not implemented") },
    fetchListByDedicated: () => { throw new Error("not implemented") },
    //    sudoAssignDedicatedAssistant: () => { throw new Error("not implemented") },
});


const IdentityProvider = observer(({ children }: { children: React.ReactNode  })=> {

    const { identityStore } = useContext(RootStoreContext);
    const [fetchedIdentities, setFetchedIdentities] = useState([] as string[]);

    // const [identities, setIdentities] = useState(identityStore.items);
    // useEffect(() => {
    //     setIdentities(identityStore.items);
    // }, [identityStore.items, setIdentities]);

    const fetchIdentity = async (myIdentity: string, identityKey: string) => {
        if (fetchedIdentities.includes(identityKey)) {
            return;
        }
        setFetchedIdentities([...fetchedIdentities, identityKey]);
        identityStore.fetchIdentity(myIdentity, identityKey);
    }

    const fetchAllIdentities = (identityKey: string) => {
        return identityStore.fetchAllIdentities(identityKey);
    }

    const getIdentity = (identityKey: string) => {
        return identityStore.getIdentity(identityKey);
    }
    const sudoSetVerified = async (identityKey: string, verified: boolean) => {
        return identityStore.sudoSetVerified(identityKey, verified ? 'yes':'requested').then((identity: Identity) => {
            //            setIdentities(identityStore.items);
            return identity;
        });
    }

    const sudoSetDedicated = async (identityKey: string, dedicated: boolean) => {
        return identityStore.sudoSetDedicated(identityKey, dedicated ? 'yes':'no').then((identity: Identity) => {
            //            setIdentities(identityStore.items);
            return identity;
        });
    }


    const sudoSetOnCallSupport = async (workKey: string, identityKey: string) => {
        return identityStore.sudoSetOnCallSupport(workKey, identityKey).then((identity: Identity) => {
            //            setIdentities(identityStore.items);
            return identity;
        });
    }


    // const sudoAssignDedicatedAssistant = async (identityKey: string, dedicatedIdentityKey: string) => {
    //     return identityStore.sudoAssignDedicatedAssistant(identityKey, dedicatedIdentityKey).then((identity: Identity) => {
    //         setIdentities(identityStore.items);
    //         return identity;
    //     });
    // }


    const supportFetchIdentityForUser = async (userKey: string) => {
        return identityStore.supportFetchIdentityForUser(userKey);
    }

    const supportGetUserUuid = async (identityKey: string) => {
        return identityStore.supportGetUserUuid(identityKey)
    }

    const managerCreateIdentity = async (
        workKey: string,
        user_uuid: string,
        name: string
    ) => {
        return identityStore.managerCreateIdentity(workKey, user_uuid, name).then((identity: IdentityProps | null) => {
            if(identity === null) {
                throw new Error("Failed to create identity");
            }
            return identity;
        });
    }

    const fetchListByTeam = async (identity: string, team: string) => {
        return identityStore.fetchListByTeam(identity, team);
    }

    const fetchListByDedicated = async (identity: string) => {
        return identityStore.fetchListByDedicated(identity);
    }

    const data = {
        identities: identityStore.items,
        fetchAllIdentities,
        getIdentity,
        fetchIdentity,
        sudoSetVerified: sudoSetVerified,
        sudoSetDedicated: sudoSetDedicated,
        supportFetchIdentityForUser: supportFetchIdentityForUser,
        supportGetUserUuid: supportGetUserUuid,
        managerCreateIdentity: managerCreateIdentity,
        sudoSetOnCallSupport: sudoSetOnCallSupport,
        fetchListByTeam: fetchListByTeam,
        fetchListByDedicated: fetchListByDedicated,
        //        sudoAssignDedicatedAssistant: sudoAssignDedicatedAssistant,
        //defaultIdentity
    }
    return (
        <IdentityContext.Provider value={data}>{ children }</IdentityContext.Provider>
    )

});

export { IdentityContext, IdentityProvider };
